





























































































































































































































































import { defineComponent } from '@vue/composition-api';
import { mapState } from 'vuex';
import InputRulesHelper from '@/helpers/InputRulesHelper';
import IntegratorBranchConfigurationsRepository from '@/repositories/integrator/IntegratorBranchConfigurationsRepository';
import IntegratorDatabaseConnectionsRepository from '@/repositories/integrator/IntegratorDatabaseConnectionsRepository';
import IntegratorDatabaseConnectionConfig from '@/views/integratorConfig/interfaces/forms/IntegratorDatabaseConnectionConfig';
import IntegratorDatabaseConnectionConfigRequest from '@/views/integratorConfig/interfaces/requests/IntegratorDatabaseConnectionConfigRequest';
import VMenuOptions from '@/types/VMenuOptions';
import { VForm } from '@/types/VForm';

export default defineComponent({
  name: 'IntegratorDatabaseConnectionConfigUpsert',
  data() {
    const inputRules: InputRulesHelper = new InputRulesHelper();
    const integratorBranchConfigurationsRepository:
      IntegratorBranchConfigurationsRepository = new IntegratorBranchConfigurationsRepository();
    const integratorDatabaseConnectionsRepository:
      IntegratorDatabaseConnectionsRepository = new IntegratorDatabaseConnectionsRepository();

    const databaseConnectionData: IntegratorDatabaseConnectionConfig = {
      databaseAlias: '',
      customerSystem: '',
      customerDatabaseConfigSchema: '',
      customerClient: '',
      customerUser: '',
      customerPort: '',
      customerHost: '',
      customerPassword: '',
      customerDatabase: '',
      customerConnectString: '',
      inncashDatabase: '',
      inncashControlTable: '',
      inncashTableJob: '',
      inncashUpdateControlTable: '',
    };

    const databaseClientOptions: VMenuOptions[] = [
      { value: 'mssql', text: 'Microsoft SQL Server' },
      { value: 'mysql', text: 'MySQL' },
      { value: 'oracledb', text: 'Oracle' },
      { value: 'postgres', text: 'Postgres' },
    ];

    const availableDatabaseAliasOptions: VMenuOptions[] = [];

    const loading: boolean = false;

    return {
      inputRules,
      integratorBranchConfigurationsRepository,
      integratorDatabaseConnectionsRepository,
      databaseConnectionData,
      databaseClientOptions,
      availableDatabaseAliasOptions,
      loading,
    };
  },
  computed: {
    ...mapState({
      companyGroupId: (state: any) => state.authentication.user.company_group_id as number,
    }),
    isEditing(): boolean {
      const { databaseAliasToUpdate } = this.$store.state.integrator_config;

      if (databaseAliasToUpdate) {
        return true;
      }

      return false;
    },
    pageTitle(): string {
      const actionText = this.isEditing ? 'Editar' : 'Criar';

      return `${actionText} Conexão com o Banco de Dados`;
    },
    actionButtonText(): string {
      return this.isEditing ? 'EDITAR' : 'SALVAR';
    },
  },
  async created() {
    await this.getAvailableDatabaseAlias();

    if (this.isEditing) {
      this.getDatabaseConnectionConfigData();
    }
  },
  methods: {
    async getAvailableDatabaseAlias(): Promise<void> {
      try {
        this.$dialog.startLoading();

        const availableDatabaseAlias = await this.integratorBranchConfigurationsRepository
          .getAvailableDatabaseAlias(this.companyGroupId);

        const distinctDatabaseAlias: VMenuOptions[] = availableDatabaseAlias.map((item) => ({
          text: item,
          value: item,
        }));

        this.availableDatabaseAliasOptions = distinctDatabaseAlias;
      } catch (error) {
        this.$notification.error('Houve um problema ao requisitar os dados de Banco');
      } finally {
        this.$dialog.stopLoading();
      }
    },
    async getDatabaseConnectionConfigData(): Promise<void> {
      try {
        this.loading = true;

        const { databaseAliasToUpdate } = this.$store.state.integrator_config;

        const data = await this.integratorDatabaseConnectionsRepository
          .getDatabaseConnectionConfigurationByAlias(this.companyGroupId, databaseAliasToUpdate);

        this.databaseConnectionData = {
          databaseAlias: data.databaseAlias,
          customerSystem: data.customerSystem,
          customerDatabaseConfigSchema: data.customerDatabaseConfigSchema,
          customerClient: data.customerClient,
          customerUser: data.customerUser,
          customerPort: data.customerPort,
          customerHost: data.customerHost,
          customerPassword: data.customerPassword,
          customerDatabase: data.customerDatabase,
          customerConnectString: data.customerConnectString,
          inncashDatabase: data.inncashDatabase,
          inncashControlTable: data.inncashControlTable,
          inncashTableJob: data.inncashTableJob,
          inncashUpdateControlTable: data.inncashUpdateControlTable,
        };
        this.availableDatabaseAliasOptions.unshift({
          text: data.databaseAlias,
          value: data.databaseAlias,
        });
      } catch (error) {
        this.$notification.error('Houve um problema ao requisitar os dados de configuração de conexão do banco de dados.');
      } finally {
        this.loading = false;
      }
    },
    async handleSave(): Promise<void> {
      try {
        this.$dialog.startLoading();

        const requestData = this.validateFormAndGetValuesRequest();

        if (!requestData) {
          return;
        }

        await this.integratorDatabaseConnectionsRepository
          .upsertDatabaseConnectionConfiguration(this.companyGroupId, requestData);

        this.$notification.success('Configuração de Conexão com o banco gravada com sucesso.');

        this.$store.commit('integrator_config/setDatabaseAliasToUpdate', undefined);

        this.$router.push({ name: 'IntegratorConfig' });
      } catch (error) {
        this.$notification.error('Houve um problema ao salvar o arquivo de configuração do Sinalizador de Recurso');
      } finally {
        this.$dialog.stopLoading();
      }
    },
    validateFormAndGetValuesRequest(): IntegratorDatabaseConnectionConfigRequest | null {
      const databaseConnectionForm = this.$refs.IntegratorDatabaseConnectionConfigForm as VForm;

      if (!databaseConnectionForm.validate()) {
        this.$notification.error('Há campos preenchidos incorretamente!');
        return null;
      }

      return {
        database_alias: this.databaseConnectionData.databaseAlias,
        customer_system: this.databaseConnectionData.customerSystem,
        customer_database_config_schema: this.databaseConnectionData.customerDatabaseConfigSchema,
        customer_client: this.databaseConnectionData.customerClient,
        customer_user: this.databaseConnectionData.customerUser,
        customer_port: this.databaseConnectionData.customerPort,
        customer_host: this.databaseConnectionData.customerHost,
        customer_password: this.databaseConnectionData.customerPassword,
        customer_database: this.databaseConnectionData.customerDatabase,
        customer_connect_string: this.databaseConnectionData.customerConnectString,
        inncash_database: this.databaseConnectionData.inncashDatabase,
        inncash_control_table: this.databaseConnectionData.inncashControlTable,
        inncash_table_job: this.databaseConnectionData.inncashTableJob,
        inncash_update_control_table: this.databaseConnectionData.inncashUpdateControlTable,
      };
    },
    handleCancel(): void {
      this.$store.commit('integrator_config/setDatabaseAliasToUpdate', undefined);

      this.$router.push({ name: 'IntegratorConfig' });
    },
  },
});
